import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { SettingsAccountsReceivableDTO } from "../models/accountsReceivable";
import { store } from "./store";

export default class AccountsReceivableSettingsStore {
    constructor() {
        makeAutoObservable(this);
    }

    loadingInitial = false;
    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    };

    private _accountsReceivableSettings: SettingsAccountsReceivableDTO | undefined;
    private loadingPromise: Promise<any> | null = null;
    private loadingComplete = false;

    loadAccountsReceivableSettings = async () => {
        this.loadingInitial = true;
        try {
            const result = await agent.accountsReceivableSettings.getAccountsReceivableSettings();
            runInAction(() => {
                this._accountsReceivableSettings = result;
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.setLoadingInitial(false);
        }
    };


    addAccountsReceivableSettings = async (values: SettingsAccountsReceivableDTO) => {
        this.loadingInitial = true;
        try {
            await agent.accountsReceivableSettings.addAccountsReceivableSettings(values);
        } catch (error) {
            console.log('error:', error);
        } finally {
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    updateAccountsReceivableSettings = async (values: SettingsAccountsReceivableDTO) => {
        this.loadingInitial = true;
        try {
            await agent.accountsReceivableSettings.updateAccountsReceivableSettings(values);
        } catch (error) {
            console.log('error:', error);
        } finally {
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    get accountsReceivableSettings() {
        if (!store.userStore.isLoggedIn) {
            return null;
        }

        if (!this.loadingComplete) {
            this.fetchData();
        }
        return this._accountsReceivableSettings;
    }

    fetchData = async () => {
        if (!this.loadingPromise) {
            this.loadingPromise = this.loadAccountsReceivableSettings()
                .then(r => {
                    this.loadingPromise = null;
                    this.loadingComplete = true;
                })
                .catch(e => {
                    this.loadingPromise = null;
                    throw e;
                })
        }
    }
}
